import { render } from "./Identifier.vue?vue&type=template&id=4f013214"
import script from "./Identifier.vue?vue&type=script&lang=js"
export * from "./Identifier.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__